import { doc, getDocFromServer } from 'firebase/firestore'
import firestore from '../../firestore'
import { PromotionalCode } from '@leadgen/models/client'

class PromotionalCodeService {
  fetchPromotionalCodeById = async ({ promotionalCodeId }: { promotionalCodeId: string }) => {
    const promotionalCodeRef = doc(firestore.promotionalCodes(), promotionalCodeId)
    const promotionalCodeDoc = await getDocFromServer(promotionalCodeRef)
    if (!promotionalCodeDoc.exists()) {
      return null
    }
    return promotionalCodeDoc.data() as PromotionalCode
  }
}

export default new PromotionalCodeService()
